import React, { useState, useEffect } from 'react';
import Page from 'react-page-loading'
import { getExperience } from '../api';
import _ from 'lodash';

const Resume = () => {
    const [classEl, setClass] = useState("");
    const [content, setContent] = useState({});

    useEffect(() => {
        let isMounted = true;
        getExperience((res)=>{
            if (res && isMounted) {
                setContent(res)
            }
        })
        return () => { isMounted = false };
    }, [])

    setTimeout(() => {
        setClass("active")
    }, 300)


    if (_.isEmpty(content)) return false;

    const lists = content.sort(function (a, b) {
        const aa = a.duration.replace(/[A-Za-z ]/g, "").split(/[-~]/)[1] || "3000"
        const bb = b.duration.replace(/[A-Za-z ]/g, "").split(/[-~]/)[1] || "3000"
        return parseInt(bb) - parseInt(aa);
    });

    return (

        // {/* <!-- ========== Start Resume ========== --> */}

        <section className={`resume area-bg ${classEl}`} id="resume">
            <Page loader={"rotate-spin"} color={"#A9A9A9"} size={6} duration={4}>
                <div className="container">
                    <div className="main-title">
                        <h2>Experience &amp; Education</h2>
                        <h3>My Resume</h3>
                    </div>
                    <div className="resume-content">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="education">
                                    <i className="fa fa-suitcase"></i>

                                    {
                                        lists.map((item, index) => index <= lists.length / 2 && (
                                            <div className="resume-item" key={index}>
                                                <h4>{item.company}</h4>
                                                <p>{item.role}</p>
                                                <div className="resume-date">
                                                    {item.duration}
                                                </div>
                                                <p>{item.description}</p>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="experience">
                                    <i className="fa fa-graduation-cap"></i>

                                    {
                                        lists.map((item, index) => index > lists.length / 2 && (
                                            <div className="resume-item" key={index}>
                                                <h4>{item.company}</h4>
                                                <p>{item.role}</p>
                                                <div className="resume-date">
                                                    {item.duration}
                                                </div>
                                                <p>{item.description}</p>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Page>
        </section>

        // {/* <!-- ========== End Resume ========== --> */}

    );

}

export { Resume };
